"use client";

/**
 * @file 宠物拟人化AI平台首页组件
 * @description 展示平台主要功能的首页，包括英雄区域、功能展示、用户评价和行动号召
 * 使用"use client"指令标记为客户端组件，启用交互功能
 */

// 导入页面所需的组件
import HeroSection from "@/components/ai-platform/HeroSection"; // 英雄区域组件
import FeaturesGrid from "@/components/ai-platform/FeaturesGrid"; // 功能网格组件

/**
 * 首页组件 - 网站首页
 * @returns {JSX.Element} 渲染完整的首页内容
 */
export default function Home() {
  return (
    // 主要内容区域，设置最小高度为全视口高度
    <main className="min-h-screen">
      {/* 英雄区域 - 展示平台的主要价值主张和视觉焦点 */}
      <HeroSection />

      {/* 功能网格区域 - 展示平台提供的各种AI创作功能 */}
      <FeaturesGrid />

      {/* 注意：页脚组件已在layout.tsx中全局导入，无需在此添加 */}
    </main>
  );
}